import { render } from "./NotaryPricingTeaser.vue?vue&type=template&id=60888e91"
import script from "./NotaryPricingTeaser.vue?vue&type=script&lang=js"
export * from "./NotaryPricingTeaser.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/ContentCreator/Functional/NotaryPricingTeaser.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "60888e91"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('60888e91', __exports__)) {
    api.reload('60888e91', __exports__)
  }
  
  module.hot.accept("./NotaryPricingTeaser.vue?vue&type=template&id=60888e91", () => {
    api.rerender('60888e91', render)
  })

}


export default __exports__